// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BookingIdSkeletonCard-bookingIdSkeletonBox-q_t1x {
    padding: 24px;
    background: var(--background-primary);
    border-radius: var(--radius-3) var(--radius-3) 0 0;
}

.BookingIdSkeletonCard-bookingIdSkeletonInfoContainer-UboB4 {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    gap: 18px;
    grid-gap: 18px;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
}

.BookingIdSkeletonCard-bookingIdSkeletonInfoTile-vJ2xx,
.BookingIdSkeletonCard-bookingIdSkeletonInfoDesc-f3qZt {
    background: var(--skeleton-secondary-bg);
    border-radius: var(--radius-5);
}

.BookingIdSkeletonCard-bookingIdSkeletonInfoTile-vJ2xx {
    max-width: 88px;
    height: 32px;
}

.BookingIdSkeletonCard-bookingIdSkeletonInfoDesc-f3qZt {
    max-width: 115px;
    height: 26px;
}

@media (max-width: 767px) {
    .BookingIdSkeletonCard-bookingIdSkeletonBox-q_t1x {
        padding: 18px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Skeleton/ViewBooking/BookingIdSkeletonCard/BookingIdSkeletonCard.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,qCAAqC;IACrC,kDAAkD;AACtD;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,yBAA8B;QAA9B,sBAA8B;YAA9B,8BAA8B;IAC9B,SAAS;IACT,cAAc;IACd,mBAAe;QAAf,eAAe;AACnB;;AAEA;;IAEI,wCAAwC;IACxC,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ","sourcesContent":[".bookingIdSkeletonBox {\n    padding: 24px;\n    background: var(--background-primary);\n    border-radius: var(--radius-3) var(--radius-3) 0 0;\n}\n\n.bookingIdSkeletonInfoContainer {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 18px;\n    grid-gap: 18px;\n    flex-wrap: wrap;\n}\n\n.bookingIdSkeletonInfoTile,\n.bookingIdSkeletonInfoDesc {\n    background: var(--skeleton-secondary-bg);\n    border-radius: var(--radius-5);\n}\n\n.bookingIdSkeletonInfoTile {\n    max-width: 88px;\n    height: 32px;\n}\n\n.bookingIdSkeletonInfoDesc {\n    max-width: 115px;\n    height: 26px;\n}\n\n@media (max-width: 767px) {\n    .bookingIdSkeletonBox {\n        padding: 18px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bookingIdSkeletonBox": `BookingIdSkeletonCard-bookingIdSkeletonBox-q_t1x`,
	"bookingIdSkeletonInfoContainer": `BookingIdSkeletonCard-bookingIdSkeletonInfoContainer-UboB4`,
	"bookingIdSkeletonInfoTile": `BookingIdSkeletonCard-bookingIdSkeletonInfoTile-vJ2xx`,
	"bookingIdSkeletonInfoDesc": `BookingIdSkeletonCard-bookingIdSkeletonInfoDesc-f3qZt`
};
module.exports = ___CSS_LOADER_EXPORT___;
